// c:\xampp\htdocs\miners-market-main\pages\KgAnalyticsPage.js

import KgAnalytics from '../components/KgAnalytics.jsx';

export default function KgAnalyticsPage() {
    return (
        <div data-name="kg-analytics-page" data-file="pages/KgAnalyticsPage.js" className="min-h-screen py-8">
            <div className="container mx-auto px-4">
                <h1 className="text-4xl font-bold text-white mb-2">KG Analytics</h1>
                <p className="text-gray-300 mb-8">Comprehensive analytics for KG International products across all categories</p>
                <KgAnalytics />
            </div>
        </div>
    );
}
